import { render } from "./ViewsErrors403.vue?vue&type=template&id=2ddf0279"
import script from "./ViewsErrors403.vue?vue&type=script&lang=js"
export * from "./ViewsErrors403.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__